import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  ExpansionPanelActions,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


class CustomExpansionPanel extends PureComponent {
  render() {
    const { children, header, submitable } = this.props;

    return (
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{ header }</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          { children }
        </ExpansionPanelDetails>
        { submitable && <ExpansionPanelActions>
          <Button type="submit" size="small" color="primary">
            Aceptar
          </Button>
        </ExpansionPanelActions> }
      </ExpansionPanel>
    );
  }
}

export default CustomExpansionPanel;

CustomExpansionPanel.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  submitable: PropTypes.bool,
};

CustomExpansionPanel.defaultProps = {
  submitable: false,
};




// WEBPACK FOOTER //
// ./src/components/ExpansionPanel.js